import '.gx{border-radius:0.625rem 0 0 0.625rem;}.ssr-plugin'
import '.gy{border-block:var(--gray-border);}.ssr-plugin'
import '.gz{border-left:var(--gray-border);}.ssr-plugin'
import '.h0{border-right:0px;}.ssr-plugin'
import '.b9{padding:0px;}.ssr-plugin'
import '.ap{cursor:pointer;}.ssr-plugin'
import '.c0{background:none;}.ssr-plugin'
import '.h1{border-radius:0 0.625rem 0.625rem 0;}.ssr-plugin'
import '.h2{border-right:var(--gray-border);}.ssr-plugin'
import '.h3{border-left:0px;}.ssr-plugin'
import { Text } from '@app/components/core/typography/Text'
import Column from '@app/components/layout/Column'
import Row from '@app/components/layout/Row'
import { faMinus, faPlus } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Style, styled } from 'inlines'

export type AmountPickerProps = {
  label: string
  value: number
  setValue: React.Dispatch<React.SetStateAction<number>>
  min?: number
  max?: number
}

const commonStyles: Style = {
  width: '2.6875rem',
  height: '2.6875rem',
  display: 'flex',
  flex: '1',
  justifyContent: 'center',
  alignItems: 'center',
}

export const AmountPicker = ({
  value,
  label,
  min = 0,
  max = 10,
  setValue,
}: AmountPickerProps) => {
  const decrease = () => {
    if (value > min) {
      setValue((prev) => prev - 1)
    }
  }
  const increase = () => {
    if (value < max) {
      setValue((prev) => prev + 1)
    }
  }
  return (
    <Column gap={0}>
      <Text.Medium
        color="var(--shades-blue-500)"
        style={{ height: '2.125rem' }}
      >
        {label}
      </Text.Medium>
      <Row style={{ width: '8.0625rem' }} gap={0}>
        <styled.button className="gx gy gz h0 b9 ap c0"
          onClick={decrease}
          style={{
            ...commonStyles,}}
        >
          <FontAwesomeIcon icon={faMinus} />
        </styled.button>
        <Text.Medium
          style={{
            ...commonStyles,
            border: 'var(--gray-border)',
            userSelect: 'none',
          }}
        >
          {value}
        </Text.Medium>
        <styled.button className="h1 gy h2 h3 b9 ap c0"
          onClick={increase}
          style={{
            ...commonStyles,}}
        >
          <FontAwesomeIcon icon={faPlus} />
        </styled.button>
      </Row>
    </Column>
  )
}
